<template>
  <a-tabs type="card" default-active-key="1">
    <a-tab-pane key="1" tab="课堂作业">
      <TeacherWorkGroupByCourse />
    </a-tab-pane>
    <a-tab-pane key="2" tab="自定义作业">
      <TeacherAdditionalWorkGroupByDepart />
    </a-tab-pane>
    <a-tab-pane key="3" tab="作业推荐">
      <a-tabs default-active-key="4" @change="recommendTabChange">
        <a-tab-pane key="4" tab="正在展示">
          <TeacherWorkRecommend ref="teacherWorkRecommend"/>
        </a-tab-pane>
        <a-tab-pane key="5" tab="历史展示">
          <TeacherWorkRecommendHistory ref="teacherWorkRecommendHistory"/>
        </a-tab-pane>
      </a-tabs>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import TeacherAdditionalWorkGroupByDepart from "./TeacherAdditionalWorkGroupByDepart.vue";
import TeacherWorkGroupByCourse from "./TeacherWorkGroupByCourse.vue";
import TeacherWorkRecommend from './TeacherWorkRecommend'
import TeacherWorkRecommendHistory from './TeacherWorkRecommendHistory'
export default {
  name: "TeacherWorkGroup",
  components: {
    TeacherAdditionalWorkGroupByDepart,
    TeacherWorkGroupByCourse,
    TeacherWorkRecommend,
    TeacherWorkRecommendHistory
  },
  methods:{
    recommendTabChange(v){
      if(v == 4){
        this.$refs.teacherWorkRecommend.search()
      }else{
        this.$refs.teacherWorkRecommendHistory.search()
      }
    }
  }
};
</script>

<style>
</style>